import { IActivity } from "@miplatform/types";
import { ActivityDateRange, MiActivityLog } from "@mibuildweb/components";

export const PriceLevelHistory = ({
  priceLevelActivities,
  isLoading,
  dateRange,
  onDateRangeChange,
}: PriceLevelHistoryProps) => {
  return (
    <MiActivityLog
      activities={priceLevelActivities}
      isLoading={isLoading}
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      showDateRangePicker
    />
  );
};

type PriceLevelHistoryProps = {
  priceLevelActivities: IActivity[];
  isLoading: boolean;
  dateRange: ActivityDateRange;
  onDateRangeChange: (range: ActivityDateRange) => void;
};
